import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMytaverseEvent } from '@core/dashboard/providers';
import ROUTES from '@constants/routes';
import PageWrapper from '@components/PageWrapper';
import SelectAvatarProviderPageView from './SelectAvatarProviderPageView';
import { useMytaverse } from '@providers/MytaverseProvider';
import { hasSelectableAvatars } from '@helpers/avatar';
import { env } from 'env';

const {
  REACT_APP_FEATURE_AVATURN,
  REACT_APP_FEATURE_READY_PLAY_ME,
  REACT_APP_FEATURE_AVATARS_CUSTOM,
} = env;

/**
 * Routes the avatar step to the right screen: the user's avatar list, avatar
 * creation, or the provider picker when more than one provider is enabled.
 */
const SelectAvatarProviderPage = () => {
  const { currentEventId, previousSkin, previousCustomAvatar } =
    useMytaverseEvent();
  const { user, wantsToCreateAvatar, setWantsToCreateAvatar } = useMytaverse();
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  const features = [
    REACT_APP_FEATURE_AVATURN,
    REACT_APP_FEATURE_READY_PLAY_ME,
    REACT_APP_FEATURE_AVATARS_CUSTOM,
  ];
  const trueCount = features.filter((feature) => feature === 'true').length;

  useEffect(() => {
    // if there is anything to select — an avatar of their own or the default
    // one — and the user is not actively trying to create a new avatar, then
    // redirect to the user's multi avatar selection screen
    if (!wantsToCreateAvatar && hasSelectableAvatars(user)) {
      navigate(ROUTES.SELECT_USER_AVATAR(currentEventId), { replace: true });
    } else {
      if (trueCount === 1) {
        if (REACT_APP_FEATURE_AVATURN === 'true') {
          // redirecting to the selection of avaturn type
          navigate(ROUTES.SELECT_AVATURN(currentEventId), { replace: true });
        }
      }
    }
    return () => {
      setWantsToCreateAvatar(false);
    };
  }, []);

  if (trueCount <= 1) {
    return null;
  }

  return (
    <PageWrapper title={translate('selectAvatar.title')}>
      <SelectAvatarProviderPageView
        hasPreviousAvatar={!!previousSkin || !!previousCustomAvatar}
      />
    </PageWrapper>
  );
};

export default SelectAvatarProviderPage;
